/** @file tileIsBlank: whether every pixel of a tile is fully transparent (Save then clears the slot). */
import type { Image } from '@zilo/pose3d-image-io/types/image';

/** True when every alpha byte is 0 (an angle never painted has no image). */
export function tileIsBlank(image: Image): boolean {
  for (let i = 3; i < image.data.length; i += 4) if (image.data[i] !== 0) return false;
  return true;
}
